<template>
    <div class="contenedor">
        <cartamenu
            :subitems="nav"
            v-bind:class="[activeMenuCarta ? 'mostrar' : '', 'ocultar']"
        ></cartamenu>
        <listcat
            :subitems="nav"
            v-bind:class="[activeMenuCategories ? 'mostrar' : '', 'ocultar']"
        ></listcat>
        <mopt
            :subitems="nav"
            v-bind:class="[activeMenuOptions ? 'mostrar' : '', 'ocultar']"
        ></mopt>
    </div>
</template>

<script>
import cartamenu from "@/components/dimenu/menu/menu_submenu.vue";
import listcat from "@/components/dimenu/menu/menu_categories.vue";
import mopt from "@/components/dimenu/menu/menu_opciones.vue";
import { mapGetters } from "vuex";
export default {
    name: "menu_cuerpo",
    components: {
        cartamenu,
        listcat,
        mopt,
    },
    props: {
        items: { type: Object, required: true },
    },
    data () {
        return {
            nav: {},
            activeMenuCarta: false,
            activeMenuCategories: false,
            activeMenuOptions: false,
        }
    },
    created () {
        this.nav = this.items;
        // console.log('nav', this.nav)
        this.mostrarComponent(this.nav);
    },
    methods: {
        mostrarComponent() {
            // console.log('activando componente', this.nav.id)
            if (this.nav.id === 1) {
                this.activeMenuCarta = true;
                this.activeMenuCategories = false;
                this.activeMenuOptions = false;
            }
            if (this.nav.id === 2) {
                this.activeMenuCarta = false;
                this.activeMenuCategories = true;
                this.activeMenuOptions = false;
            }
            if (this.nav.id === 3) {
                this.activeMenuCarta = false;
                this.activeMenuCategories = false;
                this.activeMenuOptions = true;
            }
        },
    },
    watch: {
        "get_menutab.id": function () {
            this.nav = this.get_menutab;
            // console.log('watch nav', this.nav);
            this.mostrarComponent();
        },
    },
    computed: {
        ...mapGetters(["get_menutab"]),
    },
}
</script>

<style lang="scss" scoped>
.mostrar {
    display: flex !important;
}
.ocultar {
    display: none;
}
</style>
